<template>
    <CustomDialog
        v-if="$store.state.dialog.active"
        :show-header-divider="true"
        :show-close-button="$store.state.dialog.showCloseButton"
        :title="$store.state.dialog.title"
        @close="onClick"
    >
        <div class="alert-dialog">
            <div v-if="$store.state.dialog.type === 'logout'">
                <img
                    src="@/assets/images/dialog/logout.svg"
                    loading="lazy"
                    alt="logout"
                >
            </div>
            <div v-else-if="$store.state.dialog.type === 'remind'">
                <img
                    src="@/assets/images/dialog/remindBell.svg"
                    loading="lazy"
                    alt="remindBell"
                >
            </div>
            <div v-else-if="$store.state.dialog.type === 'info'">
                <img
                    src="@/assets/images/dialog/alert.svg"
                    loading="lazy"
                    alt="alert"
                >
            </div>
            <div v-else>
                <img
                    src="@/assets/images/dialog/error.svg"
                    loading="lazy"
                    alt="error"
                >
            </div>
            <div
                class="alert-dialog__content"
                v-html="cleanHtml"
            >
            </div>
            <div class="alert-dialog__actions">
                <button
                    type="button"
                    class="alert-dialog__button"
                    @click="onClick"
                >
                    {{ $store.state.dialog.confirmButtonText }}
                </button>
            </div>
        </div>
    </CustomDialog>
</template>

<script>
import CustomDialog from '@/components/Dialog';
/**
 *  彈跳視窗-紅圓驚嘆號警示
 */
export default {
    name: 'AlertDialog',
    components: {
        CustomDialog
    },
    computed: {
        /**
         * 使用 DOMPurify 將傳入的 html 進行字串的清理，防止 XSS 攻擊
         *
         * @returns {String} 回傳處理過的 HTML 字串
         * @public
         */
        cleanHtml() {
            return DOMPurify.sanitize(this.$store.state.dialog.text, { ADD_ATTR: ['target'] });
        }
    },
    methods: {
        /**
         *  關閉彈跳視窗
         * 
         *  @public
         */
        onClick() {
            this.$store.state.dialog.closeFunc();
        }
    }
};
</script>

<style scoped lang="scss">
.alert-dialog {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 3rem 0;
    padding: 0 2.5rem;
}

.alert-dialog__content {
    margin-top: 2rem;
    text-align: center;
    width: 100%;
    word-break: break-word;
}

.alert-dialog__actions {
    margin-top: 4rem;
    display: flex;
    justify-content: center;
    gap: 1rem;

    @media (min-width: 1280px) {
        gap: 1rem;
        display: flex;
    }
}

.alert-dialog__button {
    border-radius: 9999px;
    width: 136px;
    padding: 0.5rem;
    font-size: 18px;
    color: #4f4f4f;
    border: 1px solid transparent;
    background-color: #FFCC00;
    @media (min-width: 1280px) {
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
    }
}
</style>